function initFeatureLpAnimations(root) {
  root = root || document;

  var animatedItems = root.querySelectorAll('.flp-animate-on-scroll:not([data-flp-animation-initialized="true"])');

  if (!animatedItems.length || !('IntersectionObserver' in window)) {
    animatedItems.forEach(function (item) {
      item.classList.add('flp-is-visible');
      item.dataset.flpAnimationInitialized = 'true';
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        var replay = el.dataset.flpAnimationReplay === 'true';

        if (entry.isIntersecting) {
          el.classList.add('flp-is-visible');

          if (!replay) {
            observer.unobserve(el);
          }
        } else if (replay) {
          el.classList.remove('flp-is-visible');
          void el.offsetWidth;
        }
      });
    },
    {
      root: null,
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    }
  );

  animatedItems.forEach(function (item) {
    item.dataset.flpAnimationInitialized = 'true';
    observer.observe(item);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initFeatureLpAnimations(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initFeatureLpAnimations(event.target);
});
